import { render, staticRenderFns } from "./Descarte.vue?vue&type=template&id=da3ca94e&"
import script from "./Descarte.vue?vue&type=script&lang=js&"
export * from "./Descarte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports